document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const menuCloseButtons = document.querySelectorAll('[data-menu-close]');

function setMobileMenu(open) {
  if (!menuButton || !mobileMenu) return;
  menuButton.setAttribute('aria-expanded', String(open));
  mobileMenu.hidden = !open;
  document.body.classList.toggle('menu-open', open);
  if (open) {
    const closeButton = mobileMenu.querySelector('.mobile-nav__close');
    if (closeButton) closeButton.focus();
  } else {
    menuButton.focus();
  }
}

if (menuButton && mobileMenu) {
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    setMobileMenu(!open);
  });

  menuCloseButtons.forEach((button) => {
    button.addEventListener('click', () => setMobileMenu(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
      setMobileMenu(false);
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1000 && menuButton.getAttribute('aria-expanded') === 'true') {
      setMobileMenu(false);
    }
  });
}

const productForm = document.querySelector('[data-product-form]');
if (productForm) {
  productForm.addEventListener('submit', () => {
    const btn = productForm.querySelector('button[name="add"]');
    if (btn && !btn.disabled) btn.textContent = 'Agregando…';
  });
}

// DUREP v1.13 — lightweight contact-form bot friction.
// Shopify hCaptcha remains the primary server-side anti-bot layer.
document.querySelectorAll('form.durep-contact-form').forEach((form) => {
  const startedAt = Date.now();
  const honeypot = form.querySelector('[data-contact-honeypot]');
  const warning = form.querySelector('[data-contact-fast-warning]');
  const submit = form.querySelector('[data-contact-submit]');

  form.addEventListener('submit', (event) => {
    const tooFast = Date.now() - startedAt < 2500;
    const trapFilled = honeypot && honeypot.value.trim() !== '';

    if (trapFilled || tooFast) {
      event.preventDefault();
      if (warning) warning.hidden = false;
      return;
    }

    if (warning) warning.hidden = true;
    if (submit && !submit.disabled) {
      submit.disabled = true;
      const label = submit.querySelector('span');
      if (label && submit.dataset.sendingLabel) label.textContent = submit.dataset.sendingLabel;
    }
  });
});
